import { useQuery } from '@tanstack/react-query';
import { GenQrBidvVAEntity, BidvVirtualAccountService } from 'services/openapi';

import { BidvVirtualAccountServiceQueryKeys } from '../constants';

type GenQrBidvVAQueryDTO = {
  vaPrefix: string;
  endCode: string;
  enabled?: boolean;
};

export const useGenQrBidvVAQuery = (variables: GenQrBidvVAQueryDTO) => {
  const { enabled = true, endCode, vaPrefix } = variables;
  const queryKey = [
    BidvVirtualAccountServiceQueryKeys.GEN_QR,
    vaPrefix,
    endCode,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GenQrBidvVAEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvVirtualAccountService.bidvVaControllerGenQr(vaPrefix, endCode),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !!vaPrefix && !!endCode,
  });

  return {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};
